module.exports = __webpack_public_path__ + "img/close_white.8df2fa7e.svg";